var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { ComponentTypesClient, GetComponentTypeListPaginatedQuery, PaginatedEnumerableOfComponentTypeModel, ComponentTypeModel, UpdateComponentTypeCommand, CreateComponentTypeCommand } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
const componentTypeClient = new ComponentTypesClient(window.apiUrl);
let ComponentTypesVue = class ComponentTypesVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        // models
        this.query = new GetComponentTypeListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
        });
        this.data = new PaginatedEnumerableOfComponentTypeModel();
    }
    created() {
        this.search();
    }
    ;
    // get
    search() {
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        componentTypeClient
            .getListPaginated(this.query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    // set
    add() {
        let componentType = new ComponentTypeModel({
            componentTypeId: 0,
            componentTypeName: ""
        });
        if (!this.data.records)
            this.data.records = new Array();
        this.data.records.unshift(componentType);
    }
    ;
    save(componentType) {
        if (!componentType.componentTypeName) {
            Notifier.onError("Please enter a component type.");
            return;
        }
        let promise = () => {
            return componentType.componentTypeId
                ? componentTypeClient.update(componentType.componentTypeId, new UpdateComponentTypeCommand({ requestModel: componentType }))
                : componentTypeClient.add(new CreateComponentTypeCommand({ requestModel: componentType }));
        };
        promise()
            .then(() => {
            Notifier.onOk(this);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.search();
        });
    }
    ;
    purge(componentType) {
        if (!componentType.componentTypeId && this.data.records) {
            this.data.records.splice(this.data.records.indexOf(componentType), 1);
            return;
        }
        this.$confirmModal.show("Are you sure that you want to permanently delete this component type? This action cannot be undone.", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            componentTypeClient
                .delete(componentType.componentTypeId)
                .then(() => {
                Notifier.onOk();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.search();
            });
        });
    }
    ;
    // computed
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
};
__decorate([
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ComponentTypesVue.prototype, "search", null);
ComponentTypesVue = __decorate([
    Component({
        name: "ComponentTypesVue"
    })
], ComponentTypesVue);
export default ComponentTypesVue;
